import { injectable } from "inversify";
import ValidationService from "../ValidationService";

@injectable()
export default class SipoValidator {
  private readonly _weights = [3, 7, 3, 1, 7, 3, 1, 7, 3];

  private readonly _validationService: ValidationService;

  constructor() {
    this._validationService = new ValidationService();
  }

  validateSipo(sipo: string, validateRegex: boolean = true): boolean {
    if (validateRegex && !this._validationService.validateRegex(sipo, /^\d{10}$/)) {
      return false;
    }

    let lastNumber = Number(sipo[9]);
    let controlNumber = this.calculateControlNumber(sipo);

    return lastNumber === controlNumber;
  }

  private calculateControlNumber(sipo: string): number {
    let sum = 0;

    for (let i = 0; i < sipo.length - 1; i++) {
      sum += this._weights[i] * Number(sipo[i]);
    }

    let lastNumber = sum % 10;

    return lastNumber === 0 ? 0 : (10 - lastNumber);  
  }
}